/**
 * @file view-required-info.tsx
 * @module app/modals/view-required-info
 * @description Renders the view required info modal dialog for confirming actions, capturing workflow input, and reporting outcomes to its parent screen.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CrossSvg from '../../_admin/assets/media/close.png';
const ViewRequiredInfo = (props: any) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(() => {
    if (props.edit === false) {
      setShow(false);
    }
  }, [props.edit]);
  return (
    <>
      <Button
        variant="light-primary "
        size="sm"
        className="uw-btn uw-btn-sm fs-14 fw-600 ms-2"
        onClick={handleShow}
      >
        View required info
      </Button>
      <Modal
        show={show}
        onClick={() => {
          handleClose();
        }}
        dialogClassName="modal-dialog-centered min-w-lg-590px"
        className="border-r10px"
      >
        <Modal.Header className="border-bottom-0 pb-0 text-center mx-auto">
          <img
            className="close-inner-top"
            width={40}
            height={40}
            src={CrossSvg}
            alt="closebutton"
            onClick={() => {
              handleClose();
            }}
          />
          <Modal.Title className="fs-26 fw-bolder mw-lg-375px pt-5">
            Information required from {props.ownerName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-4 pt-5">
          {/* <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="bg-light-warning text-center border-r10px p-3">
                <span className="fs-18 fw-500">{props.message}</span>
              </div>
            </div>
          </div> */}
          {props.edit ? (
            <Form.Group controlId="exampleForm.ControlTextarea1">
              <Form.Control
                className="form-control-custom"
                as="textarea"
                rows={5}
                placeholder="Please type the the information you require here…"
                onChange={props.onMessageChange}
                value={props.message}
              />
            </Form.Group>
          ) : (
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <div className="bg-light-warning text-center border-r10px p-3">
                  <span className="fs-18 fw-500">{props.message}</span>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="justify-content-center pt-5 py-8 mb-4 border-top-0">
          <Button
            variant=""
            className="btn btn-flush text-gray fs-16 fw-600"
            onClick={!props.edit ? props.handleEdit : props.saveChanges}
          >
            {!props.edit ? (
              'Edit required info.'
            ) : props.statusLoading ? (
              <span
                className="indicator-progress"
                style={{ display: 'block' }}
              >
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            ) : (
              'Save Changes'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default ViewRequiredInfo;
